<mat-toolbar color="primary" class="header">
  <div class="header__logo-container">
    <button class="icon-btn" id="sidenav-toggle-btn" (click)="sidenavToggle.emit()">
      <mat-icon>menu</mat-icon>
    </button>
    <ng-content select="[logo]"></ng-content>
    @if (displaySwitchApp()) {
      <button
        mat-icon-button
        class="switch-app"
        matTooltip="Switch app"
        [matMenuTriggerFor]="switchApp"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #switchApp="matMenu">
        <ng-content select="[switchApp-dropdown]"></ng-content>
      </mat-menu>
    }
  </div>
  <div class="header__navigation-container">
    <ng-content select="[nav-items]"></ng-content>
  </div>
  <div class="header__btns-container">
    <button class="icon-btn" id="help-btn" [matMenuTriggerFor]="helpMenu">
      <mat-icon>help</mat-icon>
    </button>
    <mat-menu #helpMenu="matMenu">
      <ng-content select="[help-dropdown]"></ng-content>
    </mat-menu>

    <button class="icon-btn" id="account-btn" [matMenuTriggerFor]="accountMenu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #accountMenu="matMenu" id="account-menu">
      <ng-content select="[account-dropdown]"></ng-content>
    </mat-menu>
  </div>
</mat-toolbar>
